export const paginationScript=(oktaBaseUrl,pageSize) =>{
    
  

    return `
        var defaultLink = '${oktaBaseUrl}?limit=${pageSize}';

        if(response && response.headers && response.headers.link){
            // Use regular expression to extract the URL with rel="next"
            const match = /<([^>]+)>;\s*rel="next"/.exec(response.headers.link);
            const nextUrl = match && match[1];   
            return nextUrl;
        }
        return defaultLink;
    `
}